import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {select, actions} from './connectors';

import {reorderTop, reorderBottom} from '~/constants/InlineSvgs';
import ActionPillsMenu from '~/shared/components/ActionPillsMenu';
import ActionPill from '~/shared/components/ActionPill';
import {vibrate} from '~/utils/vibrate';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export const LayeringPills = props => {
  const {
    actions: {sendToBack},
    actions: {sendToFront},
    actives: {canSendToBack},
    actives: {canSendToFront}
  } = props;

  const handleSendToBack = () => {
    if (!canSendToBack || !sendToBack) {
      return;
    }

    vibrate();
    sendToBack({
      source: 'mobile_layering_pills'
    });
  };

  const handleSendToFront = () => {
    if (!canSendToFront || !sendToFront) {
      return;
    }

    vibrate();
    sendToFront({
      source: 'mobile_layering_pills'
    });
  };

  return (
    <ActionPillsMenu>
      {canSendToFront && (
        <ActionPill
          className={'canSendToFrontBtn'}
          icon={reorderTop}
          text={'Send to Front'}
          onClick={handleSendToFront}
        />
      )}
      {canSendToBack && (
        <ActionPill
          className={'canSendToBackBtn'}
          icon={reorderBottom}
          text={'Send to Back'}
          onClick={handleSendToBack}
        />
      )}
    </ActionPillsMenu>
  );
};

const propTypes = {
  actions: PropTypes.shape({
    sendToBack: PropTypes.func,
    sendToFront: PropTypes.func
  }).isRequired,
  actives: PropTypes.shape({
    canSendToBack: PropTypes.bool,
    canSendToFront: PropTypes.bool
  })
};

LayeringPills.propTypes = propTypes;

export default connect(select, actions)(LayeringPills);
